export default "__VITE_ASSET__15925dd0__"